import { CurrencyEnum } from '@/types/filters'

export const DEFAULT_CURRENCY_ID = CurrencyEnum.HKD

export const currencyIdNewUserGiftMap: Record<number, string> = {
  [CurrencyEnum.TWD]: 'TWD 300',
  [CurrencyEnum.HKD]: 'HKD 75',
  [CurrencyEnum.MYR]: 'MYR 30',
  [CurrencyEnum.THB]: 'THB 300',
  [CurrencyEnum.PHP]: 'PHP 300',
  [CurrencyEnum.SGD]: 'SGD 15',
}
